<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-user-plus"></i> Add Guest
    <app-page-help articleId="g8uirxp7vu"></app-page-help>
  </h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <span><i class="fas fa-times"></i></span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-sm-12">
        <mat-form-field class="mat-block">
          <input type="text" matInput required placeholder="Name" formControlName="name" />
          <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
            Name is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <mat-form-field class="mat-block">
          <input type="email" matInput required placeholder="Email" formControlName="email" />
          <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('required')">
            Email is <strong>required</strong>
          </mat-error>
          <mat-error *ngIf="form.get('email').touched && form.get('email').hasError('email')">
            Email must have valid format
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <mat-form-field class="mat-block">
          <input type="text" formControlName="phone" matInput placeholder="Phone" />
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <mat-form-field class="mat-block">
          <input type="text" formControlName="city" matInput placeholder="City" />
        </mat-form-field>
      </div>
      <div class="col-sm-12">
        <ng-select
          [items]="countryList"
          [selectOnTab]="true"
          [clearable]="false"
          bindLabel="name"
          bindValue="name"
          formControlName="country"
          placeholder="Country"
          class="mat-block"
        >
        </ng-select>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="create(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-plus"></i> create
  </button>
</div>
